/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface FlightPassengerComposition
 */
export interface FlightPassengerComposition {
    /**
     *
     * @type {number}
     * @memberof FlightPassengerComposition
     */
    adults: number;
    /**
     *
     * @type {number}
     * @memberof FlightPassengerComposition
     */
    children: number;
    /**
     *
     * @type {number}
     * @memberof FlightPassengerComposition
     */
    infantsWithoutSeat: number;
}

/**
 * Check if a given object implements the FlightPassengerComposition interface.
 */
export function instanceOfFlightPassengerComposition(value: object): value is FlightPassengerComposition {
    if (!('adults' in value) || value['adults'] === undefined) return false;
    if (!('children' in value) || value['children'] === undefined) return false;
    if (!('infantsWithoutSeat' in value) || value['infantsWithoutSeat'] === undefined) return false;
    return true;
}

export function FlightPassengerCompositionFromJSON(json: any): FlightPassengerComposition {
    return FlightPassengerCompositionFromJSONTyped(json, false);
}

export function FlightPassengerCompositionFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightPassengerComposition {
    if (json == null) {
        return json;
    }
    return {

        'adults': json['adults'],
        'children': json['children'],
        'infantsWithoutSeat': json['infants_without_seat'],
    };
}

export function FlightPassengerCompositionToJSON(json: any): FlightPassengerComposition {
    return FlightPassengerCompositionToJSONTyped(json, false);
}

export function FlightPassengerCompositionToJSONTyped(value?: FlightPassengerComposition | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'adults': value['adults'],
        'children': value['children'],
        'infants_without_seat': value['infantsWithoutSeat'],
    };
}
